<template>
  <g class="fill-none" :style="[strokeStyle]" stroke-linecap="round" stroke-linejoin="round">
    <path d="M23.25.748l-9 9M9.75 20.998v-6.75H3M14.25 2.998v6.75H21M9.75 14.248l-9 9" />
  </g>
</template>

<script>
const IconMixin = require("@/mixins/IconMixin").default;
  
export default {
  name: "IconMinimize",
  mixins: [IconMixin],
  data() {
    return {};
  },
  props: {
  },
  computed: {
  }
};
</script>